import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
    makeStyles,
    withStyles
} from '@material-ui/core';
import { loadElr } from '../../../store/actions/tripActionCreator';
import RightSideBar from '../../components/RightSideBar/RightSideBar';
import { YoutubeIcon } from '../../../components/icons';
import { BiltyHomeCss as useStyles } from './BiltyCss';
import BiltyHomeIcon from '../../components/Icons/BiltyHome';
import { LandscapePicture } from '../../../components/icons';
import * as logger from '../../../logger';
import { SizeMe } from 'react-sizeme';
import { Document, Page, pdfjs } from 'react-pdf';
import parse from 'html-react-parser';
import BiltyReportView from '../../components/Dialog/BiltyReportView';


const BiltyHome = ({ open, onNext, onClose, user, trip, tripIdValue, dispatchLoadElr }) => {

    let submit;

    const [dialogOpen, setDialogOpen] = useState(open);
    const [elrData, setElrData] = useState({});
    const [pdfWidth, setPdfWidth] = useState(document.body.clientWidth - 35);
    const [numPages, setNumPages] = useState(null);
    const [biltyReportOpen, setBiltyReportOpen] = useState(false);

    const classes = useStyles();

    useEffect(() => {
        if (trip && trip.elrLoadData) {
            setElrData(trip.elrLoadData);
        }
    }, [trip.elrLoadData]);

    const handleCancel = () => {
        setDialogOpen(false);
        onClose();
    }

    const handleNextClick = () => {
        setDialogOpen(false);
        onNext();
    }

    // pdf related settings
    function onDocumentLoadSuccess({ numPages: nextNumPages }) {
        let header = document.getElementsByTagName('header')[0];
        if (header) {
            setPdfWidth(header.clientWidth - 60);
        }
        setNumPages(nextNumPages);
    }

    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

    const handleSampleReport = () => {
        setBiltyReportOpen(true);
    }

    const handleBiltyReportViewClose = () => {
        setBiltyReportOpen(false);
    }

    return (
        <>
            {dialogOpen && <RightSideBar
                sideBarName="online-bilty"
                rightSideBarOpen={dialogOpen}
                sideBarTitle={'Online Bilty'}
                sideBarType="biltyHome"
                fromBiltyHome={true}
                handleSubmit={event => submit(event)}
                nextClick={handleNextClick}
                toggleRightSideBar={handleCancel}>

                <div>

                    <div className={classes.divV2}>
                        <BiltyHomeIcon />
                        <div className={classes.divV1}>
                            <div>
                                <YoutubeIcon className={classes.youtubeIcon} />
                            </div>
                            <div className={classes.divV3}>
                                <div className={classes.divV4}>Introducing</div>
                                <div className={classes.divV5}>Online Bilty</div>
                                <div className={classes.divV6}>Create Bilty and Document your trip</div>
                                <div>easily</div>
                            </div>
                        </div>
                    </div>

                    <div className={classes.divContainer}>
                        <div className={classes.divV7} onClick={handleSampleReport}>
                            <div className={classes.divV9}>Consignor LR Sample</div>
                            <div className={classes.divV11}>

                                {elrData && elrData.sample_consignor_pdf ?
                                    (
                                        <>
                                            {/* <div dangerouslySetInnerHTML={{ __html: elrData.sample_consignor_pdf }} /> */}
                                            <div className={classes.divV13}>
                                                {parse(elrData.sample_consignor_pdf)}
                                            </div>
                                            {/* <SizeMe>
                                                {({ size }) => (
                                                    <Document
                                                        file={elrData && elrData.sample_consignor_pdf ? elrData.sample_consignor_pdf : null}
                                                        onLoadSuccess={onDocumentLoadSuccess}
                                                    >
                                                        {
                                                            Array.from(
                                                                new Array(numPages),
                                                                (el, index) => (
                                                                    <Page
                                                                        key={`page_${index + 1}`}
                                                                        pageNumber={index + 1}
                                                                        width={size.width ? size.width : 1}
                                                                    />
                                                                ),
                                                            )
                                                        }
                                                    </Document>

                                                )}
                                            </SizeMe> */}
                                        </>
                                    ) : (
                                        <LandscapePicture className={classes.iconV1} />
                                    )
                                }

                            </div>
                        </div>

                        <div className={classes.divV8} onClick={handleSampleReport}>
                            <div className={classes.divV10}>Consignee LR Sample</div>
                            <div className={classes.divV12}>

                                {elrData && elrData.sample_consignee_pdf ?
                                    (
                                        <>
                                            {/* <SizeMe>
                                                {({ size }) => (
                                                    <Document
                                                        file={elrData && elrData.sample_consignee_pdf ? elrData.sample_consignee_pdf : null}
                                                        onLoadSuccess={onDocumentLoadSuccess}
                                                    >
                                                        {
                                                            Array.from(
                                                                new Array(numPages),
                                                                (el, index) => (
                                                                    <Page
                                                                        key={`page_${index + 1}`}
                                                                        pageNumber={index + 1}
                                                                        width={size.width ? size.width : 1}
                                                                    />
                                                                ),
                                                            )
                                                        }

                                                    </Document>
                                                )}
                                            </SizeMe> */}
                                            <div className={classes.divV13}>
                                                {parse(elrData.sample_consignee_pdf)}
                                            </div>
                                        </>
                                    ) : (
                                        <LandscapePicture className={classes.iconV1} />
                                    )
                                }
                            </div>
                        </div>
                    </div>

                </div>

            </RightSideBar>}

            {biltyReportOpen && <BiltyReportView open={biltyReportOpen} onClose={handleBiltyReportViewClose} />}
        </>
    );

}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
   
});


export default connect(mapStateToProps, mapDispatchToProps)(BiltyHome);